import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 9 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.89999 6L4.29999 12H0.5L5.10001 6L0.5 0H4.29999L8.89999 6Z", fill: "#A6A6A6" }));
export default SvgArrow;
